import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectorRef,
  NgZone,
} from "@angular/core";
import { AlertController, Platform } from "@ionic/angular";
import { Insomnia } from "@awesome-cordova-plugins/insomnia/ngx";
import { HttpClient } from "@angular/common/http";
//import { BarcodeScanner } from '@capacitor-community/barcode-scanner'; //for ios
import {
  BarcodeScanner as MLKitBarcodeScanner,
  BarcodeFormat,
} from "@capacitor-mlkit/barcode-scanning"; // for android
import { Capacitor } from "@capacitor/core";
import {
  IParameterData,
  stringparametertemp,
  IHardwareVersion,
} from "@shared/interfaces/device.interface";
import { IFirmwareUpgrade } from "@interfaces/request.interface";
import {
  IFirmwareFile,
  ITarget,
  SelectedFile,
} from "@shared/interfaces/firmware.interface";
import {
  Subject,
  Subscription,
  timer,
  from,
  Observable,
  of,
  lastValueFrom,
  firstValueFrom,
  combineLatest,
  EMPTY,
} from "rxjs";
import { Router } from "@angular/router";
import { RemoteUserService } from "@state/remote-user/remote-user.service";
import { FirestoreService } from "@shared/services/firestore.service";
import { ConnectApiService } from "@shared/services/connectapi.service";
import { BleCapacitorService } from "@shared/services/ble/ble-capacitor.service";
import { DeviceService } from "@shared/state/device/device.service";
import { TranslateService } from "@ngx-translate/core";
import { ModalService } from "@shared/services/modal.service";
import { StorageService } from "@shared/services/storage.service";
import { FirmwareService } from "@shared/state/firmware/firmware.service";
import { IstringParameterForUpdate } from "@shared/interfaces/request.interface";
import { DeviceQuery } from "@shared/state/device/device.query";
import { FirmwareQuery } from "@shared/state/firmware/firmware.query";

import {
  map,
  mergeMap,
  takeUntil,
  filter,
  tap,
  timeout,
  catchError,
  switchMap,
} from "rxjs/operators";
import { DefinitionsQuery } from "@shared/state/definitions/definitions.query";
import { ParamResponseResult } from "connectapi/src/CAN_Messages/CanMessages";
import { StringParameterEventType } from "connectapi/src/ApiMessage/apiResponseTypes";
import {
  Firestore,
  collectionData,
  CollectionReference,
  where,
  getDocs,
  query as firestoreQuery,
  Timestamp,
  doc,
  getDoc,
  collection,
  writeBatch,
  setDoc,
  updateDoc,
} from "@angular/fire/firestore";
import {
  Storage,
  ref,
  listAll,
  ListResult,
  StorageReference,
  getMetadata,
  list,
} from "@angular/fire/storage";

import { CONFIG } from "@shared/constants/config";
import { environment } from "@env/environment";
import { ECU_ID } from "connectapi/src/CAN_Messages/CanEnums";
import { RemoteUserQuery } from "@shared/state/remote-user/remote-user.query";
import { RemoteSupportService } from "@services/remote-support.service";

@Component({
  selector: "app-spare-part-modal",
  templateUrl: "./spare-part-modal.component.html",
  styleUrls: ["./spare-part-modal.component.scss"],
})
export class SparePartModalComponent implements OnInit, OnDestroy {
  @Input() parameter!: IParameterData;

  public ecuName: string = "";

  public qrResult: string = "";

  public qrResultConfirmation: string = "";

  private backButtonSubscription?: Subscription;

  private harwareSubscription?: Subscription;

  private parametersAndStringParametersForBackupSubscription?: Subscription;

  public readingQrScan: boolean = false;

  public step: number = 1;

  private prevStep!: number | null;

  public isMobile = false;

  public fetchFactorySettings!: boolean | undefined;

  private handleStopScanQRBound!: () => void;

  private writingData = false;

  private writingData$ = new Subject<boolean>();

  private paramsToExclude = [1074, 2137, 6008];

  public manuallyEnterSerialNumber: boolean = false;

  private fetchHasStarted = false;

  public serialNumber: string = ""; //serial number of the unit entered by the user to identified the existing unit in database
  public serialNumberInput: string = "";
  public softwareVarient: number | null = -1; //variable to save the vale of softwareVarient of unit fond with entered serial number
  public lastConnectedDate: Date | null = null;
  public unitBackupDate: Date | null = null;
  public backupVersion: any | null = null;
  private isAndroid = Capacitor.getPlatform() === "android";
  private scanInProgress = false;

  public items: any = []; //array for released version firmware
  public changedItems = []; //array for special/protected version firmware
  public checkBoxes: any[] = [];
  public checkBoxes$!: Observable<any>;
  public fileSelected: boolean = false;
  public isChecked: boolean = false;
  public isFirmwareDiff: boolean = false;
  public firmwareSent: boolean = false;
  public firmwareSparePart!: IFirmwareFile;
  public selectedFile!: string; //file selected in filepicker
  public firmwareName: string | null = null;

  public softwareVersionHeartBeat: number | null = null;
  public softwareFile!: StorageReference | undefined;
  public changedSoftwareFile!: StorageReference | undefined;
  public softwareVarientType: string | null = null;
  public autoSoftwareFile!: StorageReference | undefined;
  private hardwareSubs!: Subscription;
  public upgradeProgressSparePart$ = this.firmwareQuery.upgradeProgress$;
  public ongoingUpgradeSparePart$ = this.firmwareQuery.ongoingUpgrade$;
  private upgradeProgressSubscription!: Subscription;
  public firmwarePrepared = false;
  public currentSparepartUnit: IHardwareVersion | null = null;
  private HMI_SERIAL_NUMBER = 6;
  public hasInvalidInput = false;
  private invalidTimeout: any;

  ////////////////

  public searchingSparePart: boolean = false;
  public remoteSessionIsActive$ = this.remoteUserQuery.isActive$;
  private destroy$ = new Subject<void>();

  ////////////////

  constructor(
    private httpClient: HttpClient,
    private firmwareQuery: FirmwareQuery,
    private angularFireStorage: Storage,
    private firmwareService: FirmwareService,
    private storageService: StorageService,
    private modalService: ModalService,
    private remoteUserQuery: RemoteUserQuery,
    private firestoreService: FirestoreService,
    private connectApiService: ConnectApiService,
    private deviceQuery: DeviceQuery,
    private alertController: AlertController,
    private translateService: TranslateService,
    private deviceService: DeviceService,
    private definitionQuery: DefinitionsQuery,
    private bleCapacitorService: BleCapacitorService,
    private router: Router,
    private angularFirestore: Firestore,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private insomnia: Insomnia,
    private remoteSupportService: RemoteSupportService,
    private remoteUserService: RemoteUserService,
  ) {}

  ngOnInit(): void {
    this.insomnia
      .keepAwake()
      .then((ok) => console.log("APP IS AWAKE", ok))
      .catch((err) => console.log("ERROR", err));

    this.softwareVersionHeartBeat = null;

    this.harwareSubscription = this.deviceQuery.hardwareVersions$.subscribe(
      (hardwares) => {
        if (!hardwares.find((x) => x.ecuId === this.parameter.ecuId)) {
          if (!this.prevStep) {
            this.prevStep = this.step;
          }

          // this.lostConnectionToSparePart();
        } else if (this.prevStep) {
          if (this.step < 4 && this.prevStep > this.step) {
            this.step = this.prevStep;
            this.cdr.markForCheck();
          }
          this.prevStep = null;
        }
      },
    );

    this.ecuName = this.getEcuNameFromEcuId(this.parameter.ecuId);

    if (Capacitor.isNativePlatform()) {
      this.isMobile = true;
      // BarcodeScanner.prepare();
    } else {
      this.isMobile = false;
    }

    this.remoteUserQuery.isActive$
      .pipe(
        takeUntil(this.destroy$),
        filter((isActive) => isActive === true),
        switchMap(() =>
          combineLatest([
            this.firmwareQuery.firmwares$.pipe(
              filter((firmware) => !!firmware),
            ),
            this.remoteSupportService.serialNumberRemoteSparePart$.pipe(
              filter((v) => !!v),
            ),
          ]),
        ),
      )
      .subscribe(([firmware, serialNumber]) => {
        //  console.log("firmware", firmware);
        this.softwareVarient = firmware[0].systemId;
        this.firmwareSparePart = firmware[0];
        this.serialNumber = serialNumber;
        /* console.log(
          "softwareVarient",
          this.softwareVarient,
          "serialNumber",
          this.serialNumber,
        );*/
        this.step = 2;
        this.softwareVarientToText(this.softwareVarient);
        this.searchOnSerialNumberRemoteUpdate();
        this.prepareCheckboxRemot(this.firmwareSparePart);
      });
  }

  onKeyDown(event: KeyboardEvent) {
    // console.log("key pressed:", event.key); // 👈 confirm handler fires
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Enter",
    ];

    const isNumber = /^[0-9]$/.test(event.key);
    const isAllowed = allowedKeys.includes(event.key);

    if (!isNumber && !isAllowed) {
      event.preventDefault(); // block the character from appearing

      // show error
      this.hasInvalidInput = true;
      //  console.log("hasInvalidInput set to true"); // 👈 confirm flag is set
      clearTimeout(this.invalidTimeout);
      this.invalidTimeout = setTimeout(() => {
        this.hasInvalidInput = false;
      }, 2000);
    } else {
      // valid input — get the value for your serial number logic
      const input = event.target as HTMLInputElement;
      this.getSerialNumber(input.value);
    }
  }
  public async findSoftwareVersionHeartBeat(): Promise<number | null> {
    // console.log("findSoftwareVersionHeartBeat: waiting...");

    return firstValueFrom(
      this.deviceQuery.hardwareVersions$.pipe(
        /*tap((hardwareVersions) =>
          console.log(
            "emission received, array length:",
            hardwareVersions.length,
            hardwareVersions,
          ),
        ),*/
        map((hardwareVersions) =>
          hardwareVersions.find((x) => x.ecuId === this.parameter.ecuId),
        ),
        /* tap((unit) =>
          console.log(
            "unit found:",
            unit,
            "softwareVarient:",
            unit?.softwareVarient,
          ),
        ),*/
        filter((unit) => !!unit?.softwareVarient),
        timeout(10000), // give up after 10 seconds
        catchError((err) => {
          console.warn(
            "findSoftwareVersionHeartBeat timed out or errored:",
            err,
          );
          return of(null);
        }),
        map((unit) => {
          if (!unit) return null;
          if (unit.softwareSubVarient === 99) return null;
          this.currentSparepartUnit = unit;
          return unit.softwareVarient ?? null;
        }),
      ),
    );
  }
  public getSerialNumber(value: string) {
    this.serialNumber = value.trim(); // trim to remove leading/trailing whitespaces
  }

  public async searchOnSerialNumber(): Promise<void> {
    this.searchingSparePart = true;

    try {
      this.serialNumberInput = this.serialNumber?.trim() ?? "";
      if (!this.serialNumberInput) {
        return;
      }

      this.items = [];
      this.autoSoftwareFile = undefined;
      this.lastConnectedDate = null;
      this.unitBackupDate = null;

      const [result, backupDeviceInfo, softwareVersionHeartBeat] =
        await Promise.all([
          this.findDeviceOnSerial(this.serialNumberInput),
          this.findBackupOnSerial(this.serialNumberInput),
          this.findSoftwareVersionHeartBeat(),
        ]);
      // console.log(result, backupDeviceInfo, softwareVersionHeartBeat);
      this.softwareVersionHeartBeat = softwareVersionHeartBeat;
      // Handle backup info
      if (backupDeviceInfo) {
        const { backupDate, backupVersion } = backupDeviceInfo;

        if (backupDate === null || backupDate === undefined) {
          this.unitBackupDate = null;
          // console.log(backupDate, this.unitBackupDate);
        } else {
          this.unitBackupDate = backupDate?.toDate();
          // console.log("this.unitBackupDate is available");
        }
        if (backupVersion === null) {
          this.backupVersion = null;
          // console.log("this.backupVersion", this.backupVersion);
        } else {
          this.backupVersion = "available";
          //  console.log("this.backupVersion is available", this.backupVersion);
        }
      }

      // Nothing found at all
      if (!result && !backupDeviceInfo) {
        // console.log (result, backupDeviceInfo )
        this.step = -1;
        this.serialNumber = "";
        return;
      }
      this.step = 2;

      // If device exists in DB
      if (result) {
        const { softwareVariant, lastConnected } = result;
        this.softwareVarient = softwareVariant;
        this.lastConnectedDate = lastConnected ?? null;
      } else {
        // If only backup exists, rely on heartbeat version

        this.softwareVarient = this.softwareVersionHeartBeat || null;
      }

      const softwareVarientInternal = this.softwareVarient;
      const softwareVersionHeartBeatInternal = this.softwareVersionHeartBeat;
      // Decide how to prepare firmware
      const hasMatchingVariant =
        softwareVarientInternal != null &&
        softwareVersionHeartBeatInternal != null &&
        softwareVarientInternal > 0 &&
        softwareVarientInternal === softwareVersionHeartBeatInternal;

      if (hasMatchingVariant) {
        this.softwareVarientToText(softwareVarientInternal);
        await this.loadReleasedFirmware(softwareVarientInternal);
      } else {
        this.softwareVarient = null;
      }
    } catch (error) {
      console.error("Error while searching on serial number:", error);
      this.step = -1;
    } finally {
      this.searchingSparePart = false;
    }
    //console.log(this.softwareVarient);
  }
  public async searchOnSerialNumberRemoteUpdate(): Promise<void> {
    this.serialNumberInput = this.serialNumber;
    if (!this.serialNumberInput) {
      return;
    }

    this.lastConnectedDate = null;
    this.unitBackupDate = null;

    const [result, backupDeviceInfo] = await Promise.all([
      this.findDeviceOnSerial(this.serialNumberInput),
      this.findBackupOnSerial(this.serialNumberInput),
    ]);

    // Handle backup info
    if (backupDeviceInfo?.backupDate) {
      this.unitBackupDate = backupDeviceInfo.backupDate.toDate();
    } else {
      this.unitBackupDate = null;
    }
    // Nothing found at all
    if (!result && !backupDeviceInfo) {
      this.step = -1;
      this.serialNumber = "";
      return;
    }
    this.step = 2;

    // If device exists in DB
    if (result) {
      const { lastConnected } = result;

      this.lastConnectedDate = lastConnected ?? null;
    }
  }

  private async loadReleasedFirmware(softwareVariant: number): Promise<void> {
    const firmwareRef = ref(
      this.angularFireStorage,
      `systemversion/${softwareVariant}/0/release`,
    );

    const listResult = await listAll(firmwareRef);

    const metadataList = await Promise.all(
      listResult.items.map((item) => getMetadata(item)),
    );

    this.items = metadataList.map((metaData) => ({
      ...metaData,
      truncatedName: metaData.name
        .split("_")
        .slice(1)
        .join("_")
        .replace(".json", ""),
    }));

    this.autoSoftwareFile = this.items[0];

    if (this.autoSoftwareFile) {
      await this.preparingFirmware(this.autoSoftwareFile);
    }
  }
  public async getReleasedbyServiceFirmware(
    fullPath: string,
  ): Promise<boolean> {
    this.step = 2;
    const firmwareRef = ref(this.angularFireStorage, fullPath);

    const listResult = await listAll(firmwareRef);

    const metadataList = await Promise.all(
      listResult.items.map((item) => getMetadata(item)),
    );

    this.items = metadataList.map((metaData) => ({
      ...metaData,
      truncatedName: metaData.name
        .split("_")
        .slice(1)
        .join("_")
        .replace(".json", ""),
    }));

    this.autoSoftwareFile = this.items[0];

    if (this.autoSoftwareFile) {
      await this.preparingFirmware(this.autoSoftwareFile);
    }
    return this.fileSelected;
  }

  private softwareVarientToText(softwareVarient: number) {
    switch (softwareVarient) {
      case 2:
        this.softwareVarientType = "RCS";
        break;
      case 3:
        this.softwareVarientType = "Standalone";
        break;
      case 4:
        this.softwareVarientType = "MIC 4.0";
        break;
      case 5:
        this.softwareVarientType = "RCS II";
        break;
      case 6:
        this.softwareVarientType = "GSA";
        break;
      default:
        this.softwareVarientType = null;
        break;
    }
  }

  private getSerialParamId(ecuId: number): number | null {
    switch (ecuId) {
      case 1:
        return 74;
      case 2:
        return 137;
      default:
        return null; // unknown ecu -> cannot verify
    }
  }

  public async preparingFirmware(theFirmware: StorageReference) {
    if (theFirmware) {
      const firmwareUpgrade: IFirmwareUpgrade = {
        version: "1.0.0",
        fullPath: theFirmware.fullPath,
        name: theFirmware.name,
      };

      try {
        const jsonData = await lastValueFrom(
          this.httpClient.get<IFirmwareFile>(
            environment.functions.storageDownload,
            {
              responseType: "json",
              params: { path: firmwareUpgrade.fullPath },
            },
          ),
        );

        const fileIsSaved = await this.storageService.fileWrite(
          jsonData,
          firmwareUpgrade.fullPath,
        );
        if (fileIsSaved) {
          this.fileSelected = true;
          // console.log('Your file has been downloaded', this.fileSelected);
        } else {
          this.fileSelected = false;
          // console.log('Something went wrong while downloading');
        }

        this.firmwareSparePart = jsonData;

        this.prepareCheckbox(this.firmwareSparePart, firmwareUpgrade.fullPath);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    }
  }

  private prepareCheckbox(firmware: IFirmwareFile, firmwareName: string) {
    //console.log("preparing checkbox");

    this.checkBoxes = [];
    this.checkBoxes$ = of(this.checkBoxes);
    var matched = firmware.targets?.find(
      (x) => x.ecuId === this.parameter.ecuId,
    );

    this.checkBoxes.push({
      disabled: false,
      value: matched?.ecuName,
      ecuId: matched?.ecuId ?? matched?.hexFileDefinitions[0].ecuId,
      fromBuildNumber: null,
      toBuildNumber: null,
      isItemChecked: true,
    });

    this.checkBoxes$ = of(this.checkBoxes);
    // console.log("checkbox", this.checkBoxes.length, this.checkBoxes);

    if (this.checkBoxes.length > 0) {
      this.firmwarePrepared = true;
      var truncatedName = firmwareName
        .split("_")
        .slice(1)
        .join("_")
        .replace(".json", "");
      this.firmwareName = truncatedName;
      //  console.log("this.firmwarePrepared", this.firmwarePrepared);
    }
  }
  private prepareCheckboxRemot(firmware: IFirmwareFile) {
    //  console.log("preparing checkbox");

    this.checkBoxes = [];
    this.checkBoxes$ = of(this.checkBoxes);
    var matched = firmware.targets?.find(
      (x) => x.ecuId === this.parameter.ecuId,
    );

    this.checkBoxes.push({
      disabled: false,
      value: matched?.ecuName,
      ecuId: matched?.ecuId ?? matched?.hexFileDefinitions[0].ecuId,
      fromBuildNumber: null,
      toBuildNumber: null,
      isItemChecked: true,
    });

    this.checkBoxes$ = of(this.checkBoxes);
    // console.log("checkbox", this.checkBoxes.length, this.checkBoxes);

    if (this.checkBoxes.length > 0) {
      this.firmwarePrepared = true;
      var truncatedName = this.firmwareSparePart.buildNumber;

      this.firmwareName = truncatedName;
      //  console.log("this.firmwarePrepared", this.firmwarePrepared);
      this.remoteSupportService.remoteFirmwareReady$.next();
    }
  }

  public updateFirmware() {
    this.step = 3;
    // console.log("updateFirmware", this.checkBoxes);
    this.firmwareService.resetUpdateProgress();
    this.firmwareService.setOngoing(true);
    const firmwareToSend = this.firmwareSparePart;
    const checkboxesToSend = this.checkBoxes;
    setTimeout(() => {
      this.connectApiService.updateFirmwareSparePart(
        firmwareToSend,
        checkboxesToSend,
      );
    }, 50);

    this.firmwareSparePart = {} as IFirmwareFile;
    this.softwareFile = {} as StorageReference;
    this.fileSelected = false;
    this.isChecked = false;
    this.isFirmwareDiff = false;

    this.upgradeProgressSubscription = this.upgradeProgressSparePart$.subscribe(
      (progressArray) => {
        if (progressArray?.length > 0) {
          const progress = progressArray.find(
            (x) => x.ecuName === this.ecuName,
          );
          if (!progress) {
            return;
          }
          // console.log(progress.progress, progress.updgradeStatus);

          if (
            progress.progress === 1 &&
            progress.updgradeStatus === "Finished" &&
            this.ecuName !== "HMI"
          ) {
            this.upgradeProgressSubscription?.unsubscribe();
            setTimeout(() => {
              this.step = 4;
              this.firmwareService.setOngoing(false);
              this.upgradeProgressSubscription?.unsubscribe();
              this.firmwareService.resetUpdateProgress();
            }, 2000);
          } else if (
            this.ecuName === "HMI" &&
            progress.progress === 1 &&
            progress.updgradeStatus === "Finished"
          ) {
            /*   console.log(
              "update finished",
              progress.updgradeStatus,
              progressArray?.length,
            );*/
            this.step = 4;
            setTimeout(() => {
              // console.log("after 2000", progress.updgradeStatus);
              this.firmwareService.setOngoing(false);
              this.upgradeProgressSubscription?.unsubscribe();
              this.firmwareService.resetUpdateProgress();
              // this.closeModal();
            }, 2000);
          }
        }
      },
    );
  }

  private async findBackupOnSerial(
    serialNumber: string,
  ): Promise<{ backupDate: Timestamp; backupVersion: any } | null | undefined> {
    const isHmi = this.ecuName === "HMI";
    const effectiveSerial = isHmi
      ? this.HMI_SERIAL_NUMBER
      : Number(serialNumber);

    if (!Number.isFinite(effectiveSerial)) return null;

    try {
      const backupDocRef = doc(
        this.angularFirestore,
        `${CONFIG.firebaseCollection.backups}/${effectiveSerial}-0`,
      );
      const subCollectionRef = collection(backupDocRef, "backupParameters");

      const [docSnap, querySnapshot] = await Promise.all([
        getDoc(backupDocRef),
        getDocs(subCollectionRef),
      ]);

      if (!docSnap.exists() || querySnapshot.empty) return null;

      // NEW CHECK (non-HMI only)
      if (!isHmi) {
        const serialParamId = this.getSerialParamId(this.parameter.ecuId);

        if (serialParamId === null) return null;

        type ParamItem = { ecuId: number; parameterId: number; value: number };
        type BackupParamDoc = { parameterData?: ParamItem[] };

        const isSerialVerified = querySnapshot.docs.some((d) => {
          const data = d.data() as BackupParamDoc;
          const items = data.parameterData ?? [];
          return items.some(
            (p) =>
              p.parameterId === serialParamId && p.value === effectiveSerial,
          );
        });

        if (!isSerialVerified) return null;
      }

      const data = docSnap.data();

      if (!data) {
        // console.log("return null: docSnap.data() missing");
        return null;
      }

      return {
        backupDate: data["backupDate"] as Timestamp,
        backupVersion: data,
      };
    } catch (error) {
      console.error("Error querying Firestore:", error);
      return null;
    }
  }

  private async findDeviceOnSerial(serialNumber: string) {
    if (serialNumber) {
      try {
        const q = firestoreQuery(
          collection(this.angularFirestore, CONFIG.firebaseCollection.devices),
          where("address", "==", serialNumber),
          where("ecuId", "==", this.parameter.ecuId),
        );

        const unitFound = await getDocs(q);
        // console.log(unitFound);
        const mapped = unitFound.docs.map((y) => ({
          ...(y.data() as any),
          uid: y.id,
        }));
        // console.log(mapped);
        const unitData = mapped.find(
          (device) => !device.isSparePart && !device.isInactive,
        );
        // console.log(unitData);
        if (!unitData) {
          console.warn(
            `Device with serial number "${serialNumber}" not found or is inactive/spare.`,
          );

          return null;
        }
        return {
          softwareVariant: unitData?.softwareVarient,
          uid: unitData?.uid,
          lastConnected: (unitData?.lastConnected as Timestamp).toDate(),
        };
      } catch (error) {
        console.error("Error querying Firestore:", error);
      }
    }
  }

  // ****************** for scanning QR code**************** //
  public async startScanQR() {
    this.manuallyEnterSerialNumber = false;
    if (this.isAndroid) {
      //  console.log("this.isAndroid");
      await this.startScanQRAndroid();
    } else {
      await this.startScanQRIOS();
    }
  }

  // Android implementation using MLKit
  private async startScanQRAndroid() {
    try {
      // Prevent multiple simultaneous scans
      if (this.scanInProgress) {
        console.log("Scan already in progress");
        return;
      }
      //  console.log("startScanQRAndroid");
      this.scanInProgress = true;
      // Check camera permission for Android
      const { camera } = await MLKitBarcodeScanner.checkPermissions();

      if (camera === "denied" || camera === "limited") {
        const { camera: requestResult } =
          await MLKitBarcodeScanner.requestPermissions();
        if (requestResult === "denied" || requestResult === "limited") {
          alert("Camera permission is required to scan QR codes.");
          this.scanInProgress = false;
          return;
        }
      }
      // CRITICAL: Check if Google Barcode Scanner module is available
      const { available } =
        await MLKitBarcodeScanner.isGoogleBarcodeScannerModuleAvailable();

      if (!available) {
        console.log(
          "Google Barcode Scanner module not available, installing...",
        );

        // Show loading indicator to user
        const shouldInstall = confirm(
          "The barcode scanner needs to download additional components. This may take a few moments. Continue?",
        );

        if (!shouldInstall) {
          this.scanInProgress = false;
          return;
        }

        // Install the module
        await this.installBarcodeScannerModule();

        // After installation, check again
        const { available: availableAfterInstall } =
          await MLKitBarcodeScanner.isGoogleBarcodeScannerModuleAvailable();

        if (!availableAfterInstall) {
          alert(
            "Failed to install barcode scanner module. Please try again or restart the app.",
          );
          this.scanInProgress = false;
          return;
        }
      }

      // Bind stop function
      this.handleStopScanQRBound = this.stopScanQRAndroid.bind(this);
      const stopIcon = document.getElementById("stop-icon");
      if (stopIcon) {
        stopIcon.addEventListener("click", this.handleStopScanQRBound);
      }

      this.readingQrScan = true;

      // Show cancel button (no background hiding needed for MLKit)
      const cancelContainer = document.querySelector("#cancel-qr-container");
      if (cancelContainer) {
        cancelContainer.classList.remove("hidden");
      }

      // Start scanning with MLKit
      const result = await MLKitBarcodeScanner.scan({
        formats: [BarcodeFormat.QrCode, BarcodeFormat.DataMatrix],
      });
      //  console.log("scaned result", result?.barcodes);
      // Process scan result
      if (result?.barcodes && result.barcodes.length > 0) {
        const scannedContent = result.barcodes[0].rawValue;
        // console.log("scannedContent", scannedContent);
        const scannedSerialNumber = this.parseGS1Value(
          scannedContent,
          "10",
          "93",
        );
        // console.log("scannedSerialNumber", scannedSerialNumber);
        if (scannedSerialNumber !== null) {
          this.qrResult = scannedSerialNumber;
          await this.cleanupScannerAndroid();
          this.serialNumber = this.qrResult;
          // console.log("serialNumber", this.serialNumber);
          this.qrResult = "";
          this.searchOnSerialNumber();
          // this.searchOnQRCode();
        } else {
          console.warn("Failed to parse GS1 value from scanned content");
          alert("Invalid QR code format. Please try again.");
          await this.cleanupScannerAndroid();
        }
      } else {
        console.log("No content detected in scan");
        await this.cleanupScannerAndroid();
      }
    } catch (error) {
      console.error("QR Scan error (Android):", error);

      if (error instanceof Error) {
        alert(`Scan error: ${error.message}`);
      } else {
        alert("An error occurred while scanning. Please try again.");
      }

      await this.cleanupScannerAndroid();
    } finally {
      this.scanInProgress = false;
    }
  }

  private async installBarcodeScannerModule(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      let progressListener: any;

      try {
        // Listen to installation progress
        progressListener = await MLKitBarcodeScanner.addListener(
          "googleBarcodeScannerModuleInstallProgress",
          (event) => {
            // console.log("Installation progress:", event);

            // State values:
            // 0 = pending
            // 1 = downloading
            // 2 = installing
            // 3 = completed
            // 4 = failed
            // 5 = canceled

            if (event.state === 3) {
              //  console.log("Module installation completed");
              if (progressListener) {
                progressListener.remove();
              }
              resolve();
            } else if (event.state === 4 || event.state === 5) {
              console.error("Module installation failed or canceled");
              if (progressListener) {
                progressListener.remove();
              }
              reject(new Error("Module installation failed"));
            }
          },
        );

        // Start installation
        await MLKitBarcodeScanner.installGoogleBarcodeScannerModule();

        // Set timeout for installation (30 seconds)
        setTimeout(() => {
          if (progressListener) {
            progressListener.remove();
          }
          reject(new Error("Module installation timeout"));
        }, 30000);
      } catch (error) {
        console.error("Error installing module:", error);
        if (progressListener) {
          progressListener.remove();
        }
        reject(error);
      }
    });
  }

  private async startScanQRIOS() {
    /*

    try {
      // Check camera permission
      const permissionResult = await BarcodeScanner.checkPermission({ force: true });
      //console.log('Permission result:', permissionResult);

      if (permissionResult.denied) {
        const requestResult = await BarcodeScanner.checkPermission({ force: true });
        if (requestResult.denied || requestResult.restricted) {
          // console.log('Camera permission denied');
          alert('Camera permission is required to scan QR codes.');
          return;
        }
      }

      // Bind stop function
      this.handleStopScanQRBound = this.stopScanQR.bind(this);
      document.getElementById('stop-icon')?.addEventListener('click', this.handleStopScanQRBound);

      this.readingQrScan = true;

      // Hide background BEFORE preparing scanner
      document.querySelector('body')?.classList.add('barcode-scanner-active');
      document.querySelector('#cancel-qr-container')?.classList.remove('hidden');
      await BarcodeScanner.hideBackground();
      // Prepare scanner 
      
      const prepareResult = await BarcodeScanner.prepare();
     

      // Start scanning 
     
      const result = await BarcodeScanner.startScan();

     

      if (result && result.hasContent) {
        const res = result.content;
      

        
        const scannedSerialNumber = this.parseGS1Value(res, '10', '93');

        if (scannedSerialNumber !== null) {
          this.qrResult = scannedSerialNumber;
        }
        await BarcodeScanner.showBackground();
        await this.stopScanQR();
        this.searchOnQRCode();
      } else {
        console.log('No content detected in scan');
       
      }
    } catch (error) {
      console.error('QR Scan error:', error);
      await this.stopScanQR();
    }

*/
  }

  private parseGS1Value(
    barcodeData: string,
    startAI: string,
    endAI: string,
  ): string | null {
    // Create regex pattern to match the value between the two AIs
    // Pattern: (startAI)value(endAI)
    const pattern = new RegExp(`\\(${startAI}\\)([^(]+)\\(${endAI}\\)`);
    const match = barcodeData.match(pattern);

    return match ? match[1] : null;
  }

  private async stopScanQRAndroid() {
    this.readingQrScan = false;

    const stopIcon = document.getElementById("stop-icon");
    if (stopIcon && this.handleStopScanQRBound) {
      stopIcon.removeEventListener("click", this.handleStopScanQRBound);
    }

    const cancelContainer = document.querySelector("#cancel-qr-container");
    if (cancelContainer) {
      cancelContainer.classList.add("hidden");
    }

    try {
      await MLKitBarcodeScanner.stopScan();
    } catch (error) {
      console.error("Error stopping scanner (Android):", error);
    }
  }

  private async cleanupScannerAndroid() {
    try {
      await MLKitBarcodeScanner.stopScan();
      await this.stopScanQRAndroid();
    } catch (cleanupError) {
      console.error("Error during scanner cleanup (Android):", cleanupError);
      this.readingQrScan = false;
      this.scanInProgress = false;
    }
  }

  public async stopScanQR() {
    //console.log('Stopping QR scanner...');

    // Stop the barcode scanner
    //await BarcodeScanner.stopScan();

    // Update state
    this.readingQrScan = false;

    // Remove scanner UI
    //  await BarcodeScanner.showBackground();
    document.querySelector("body")?.classList.remove("barcode-scanner-active");
    document.querySelector("#cancel-qr-container")?.classList.add("hidden");

    // Remove event listener to prevent memory leaks
    const stopIcon = document.getElementById("stop-icon");
    if (stopIcon && this.handleStopScanQRBound) {
      stopIcon.removeEventListener("click", this.handleStopScanQRBound);
    }

    // console.log('QR scanner stopped successfully');
  }
  /*
  public async stopScanQR() {
    this.readingQrScan = false;
    this.fetchHasStarted = false;
    document.querySelector('body').classList.remove('barcode-scanner-active');
    // Remove all listeners
    //await BarcodeScanner.removeAllListeners();

    // Stop the barcode scanner
    await BarcodeScanner.stopScan();

    var cancelButton = document.querySelector('#cancel-qr-container');
    if (!cancelButton.classList.contains('hidden')) {
      cancelButton.classList.add('hidden');
    }

    document.getElementById('stop-icon').removeEventListener('click', this.handleStopScanQRBound);
  }*/
  /*
  public async searchOnQRCode(): Promise<void> {
    this.serialNumberInput = this.qrResult;
    this.serialNumber = this.qrResult;
    const result = await this.findDeviceOnSerial(this.qrResult); // searching device in firebase
    //console.log('result', result);
    const backupDeviceInfo = await this.findBackupOnSerial(this.qrResult); // searching backup device in firebase

    if (!result && this.ecuName === "HMI") {
      this.lastConnectedDate = null;
      this.step = 2;
    }

    if (result) {
      this.lastConnectedDate = null;
      this.ngZone.run(() => {
        this.step = 2;
        this.cdr.markForCheck();
      });
      this.lastConnectedDate = result.lastConnected;
    }

    if (backupDeviceInfo) {
      this.ngZone.run(() => {
        this.step = 2;
        this.cdr.markForCheck();
      });
      const { backupDate } = backupDeviceInfo;
      if (backupDeviceInfo === null) {
        this.unitBackupDate === null;
      } else if (backupDate) {
        this.unitBackupDate = backupDate.toDate();
        // console.log(this.unitBackupDate, backupDate);
      }
    }

    if (
      result === null &&
      backupDeviceInfo === null &&
      this.ecuName !== "HMI"
    ) {
      this.ngZone.run(() => {
        this.step = -1;
        this.cdr.markForCheck();
      });
      // console.log('result', this.step);
    }
  }*/

  public handleGetPrevious() {
    this.deviceService.setIsBackuping(true);
    this.fetchOldSettings();
    this.ngZone.run(() => {
      this.step = 5;
      this.cdr.markForCheck();
    });
  }

  public async fetchOldSettings() {
    var currentSerialNumber = this.getSerialnumberFromEcuId(
      this.parameter.ecuId,
    );
    var currentHardwareNumber = this.getHardwareNumberFromEcuId(
      this.parameter.ecuId,
    );

    this.fetchFactorySettings = false;
    this.firestoreService
      .fetchBackupParametersForSerialNumber(
        this.serialNumberInput,
        this.parameter.ecuId,
        this.fetchFactorySettings,
        currentHardwareNumber,
      )
      .then(async (res) => {
        try {
          await this.firestoreService.logBackup(
            currentSerialNumber,
            this.parameter?.ecuId === 6
              ? (this.deviceQuery?.parameterData
                  .find((x) => x.parameterId === 6008)
                  ?.value?.toString() ?? "")
              : (this.serialNumberInput ?? ""),
            this.getEcuNameFromEcuId(this.parameter.ecuId),
          );
          //  console.log(res, currentHardwareNumber);
          // Wait for writeParameters to complete
          await this.writeParameters(res?.parameterData);
          // console.log('writeParameters finished');
          this.startSubscribeForBackUpParameters(res, currentHardwareNumber);
          // console.log('Calling handleBackUpIsDone');
          //this.handleBackUpIsDone(res, currentHardwareNumber);
          //console.log('handleBackUpIsDone finished');
          /* setTimeout(() => {
            this.writingData = false;
            this.step = 4;
            this.firestoreService.forceFlag = true;
            // this.cdr.markForCheck();
          }, 1000);*/
          // Move to step 4 after parameters are written
        } catch (error) {
          console.error("Error during parameter writing:", error);
          this.serialNumber = "";
          this.ngZone.run(() => {
            this.step = 5;
            this.cdr.markForCheck();
          });
        }
      })
      .catch((err) => {
        console.error("COULD NOT FETCH BACKUP PARAMETERS", err);
        this.serialNumber = "";
        this.step = 5;
      });
  }

  public handleGetBackup() {
    this.step = 5;

    this.deviceService.setIsBackuping(true);
    this.fetchFactorySettings = true;

    var currentSerialNumber = this.getSerialnumberFromEcuId(
      this.parameter.ecuId,
    );
    var currentHardwareNumber = this.getHardwareNumberFromEcuId(
      this.parameter.ecuId,
    );

    this.firestoreService
      .fetchBackupParametersForSerialNumber(
        this.serialNumberInput,
        this.parameter.ecuId,
        this.fetchFactorySettings,
        currentHardwareNumber,
      )
      .then(async (res) => {
        //  console.log("fetchBackupParametersForSerialNumber result:", res);
        try {
          await this.firestoreService.logBackup(
            currentSerialNumber,
            this.parameter.ecuId === 6
              ? (this.deviceQuery.parameterData
                  .find((x) => x.parameterId === 6008)
                  ?.value?.toString() ?? "")
              : this.serialNumberInput,
            this.getEcuNameFromEcuId(this.parameter.ecuId),
          );
          // console.log('logBackup done');

          // console.log('Calling writeParameters with', res.parameterData);
          await this.writeParameters(res.parameterData);
          // console.log('writeParameters finished');
          this.startSubscribeForBackUpParameters(res, currentHardwareNumber);
          //console.log('Calling handleBackUpIsDone');
          // this.handleBackUpIsDone(res, currentHardwareNumber);
          //console.log('handleBackUpIsDone finished');
          /* setTimeout(() => {
            this.writingData = false;
            this.step = 4;
            this.firestoreService.forceFlag = true;
            // this.cdr.markForCheck();
          }, 1000);*/
          // Move to step 4 after parameters are written
        } catch (error) {
          console.error("Error during parameter writing:", error);
          this.serialNumber = "";
          this.ngZone.run(() => {
            this.step = 5;
            this.cdr.markForCheck();
          });
        }
      })
      .catch((err) => {
        console.error("COULD NOT FETCH BACKUP PARAMETERS", err);
        this.serialNumber = "";
        this.step = 5;
      });
  }

  private startSubscribeForBackUpParameters(
    res: any,
    currentHardwareNumber: string,
  ) {
    // console.log('STARTING SUBSCRIPTION');
    this.parametersAndStringParametersForBackupSubscription =
      this.deviceQuery.parametersAndStringParametersForBackup$
        .pipe(
          takeUntil(timer(this.parameter.ecuId === 6 ? 30000 : 15000)),
          takeUntil(this.writingData$),
        )
        .subscribe({
          next: (params) => {
            //console.log(`PARAM LEFT TO HANDLE ${params.length}`, params);

            if (params && params.length === 0) {
              // DONE
              this.writingData$.next(true);
            }
          },
          complete: async () => {
            //console.log('Data emission completed.');
            if (
              this.deviceQuery.parametersAndStringParametersForBackup.length ===
              0
            ) {
              // console.log('All data written.');
              this.writingData = false;
              await this.handleBackUpIsDone(res, currentHardwareNumber);

              this.step = 6;
            } else {
              this.startSubscribeForBackUpParameters(
                res,
                currentHardwareNumber,
              );
              // console.log('All data not written.', this.deviceQuery.parametersAndStringParametersForBackup);
              for (const parameter of this.deviceQuery
                .parametersAndStringParametersForBackup) {
                if (typeof parameter.value === "string") {
                  this.connectApiService.writeStringParameterToDevice({
                    ...parameter,
                    value: parameter.value as string,
                  });
                } else {
                  this.connectApiService.writeParameterToDevice({
                    ...parameter,
                    value: parameter.value as number,
                  });
                }

                await this.sleep(100);
              }
            }
          },
        });
  }

  public handleGetHMIBackup() {
    this.ngZone.run(() => {
      this.step = 5;
      this.cdr.markForCheck();
    });

    this.deviceService.setIsBackuping(true);
    this.fetchFactorySettings = true;
    var currentSerialNumber = this.getSerialnumberFromEcuId(
      this.parameter.ecuId,
    );
    var currentHardwareNumber = this.getHardwareNumberFromEcuId(
      this.parameter.ecuId,
    );
    // console.log(this.serialNumber);

    this.firestoreService
      .fetchBackupParametersForSerialNumber(
        "6",
        this.parameter.ecuId,
        this.fetchFactorySettings,
        currentHardwareNumber,
      )
      .then(async (res) => {
        this.firestoreService
          .logBackup(
            currentSerialNumber,
            this.parameter.ecuId === 6
              ? (this.deviceQuery.parameterData
                  .find((x) => x.parameterId === 6008)
                  ?.value?.toString() ?? "")
              : this.serialNumberInput,
            this.getEcuNameFromEcuId(this.parameter.ecuId),
          )
          .then(() => {
            try {
              this.writeParameters(res.parameterData);
              this.startSubscribeForBackUpParameters(
                res,
                currentHardwareNumber,
              );
            } catch (error) {
              console.error(error);
            }
          })
          .catch((error) => {
            console.error("COULD NOT LOG DATA", error);

            this.serialNumber = "";
            this.ngZone.run(() => {
              this.step = 5;
              this.cdr.markForCheck();
            });
          });
      })
      .catch((err) => {
        console.error("COULD NOT FETCH BACKUP PARAMETERS", err);

        this.serialNumber = "";
      });
  }

  public goBack() {
    this.serialNumber = "";
    this.serialNumberInput = "";
    this.lastConnectedDate = null;
    this.unitBackupDate = null;

    this.step = 1;
  }
  /************************************************ */

  private lostConnectionToSparePart() {
    this.step = 7;
  }

  private getSerialnumberFromEcuId(ecuId: number): string {
    switch (ecuId) {
      case 1:
        return (
          this.deviceQuery.specificParameterData(1074)?.value?.toString() ?? ""
        );

      case 2:
        return (
          this.deviceQuery.specificParameterData(2137)?.value?.toString() ?? ""
        );

      default:
        return "";
    }
  }

  private getHardwareNumberFromEcuId(ecuId: number): string {
    switch (ecuId) {
      case 1:
        return (
          this.deviceQuery.specificParameterData(1008)?.value?.toString() ?? ""
        );

      case 2:
        return (
          this.deviceQuery.specificParameterData(2008)?.value?.toString() ?? ""
        );
      default:
        return "";
    }
  }

  private mergedataWithStringParametersFromDefFile(dataWithStringParameters: {
    parameterData: IParameterData[];
    stringParameterData: stringparametertemp[];
  }) {
    // FETCH DEFAULT SETTINGS FOR THE PARAMETERS THAT WERENT UPLOADED AT THE FACTORY

    dataWithStringParameters.parameterData =
      dataWithStringParameters.parameterData.map((param) => {
        var paramIdAsNumber = parseInt(param.parameterId.toString());
        var valueAsNumber = parseInt(param.value.toString());
        return {
          ...param,
          parameterId:
            paramIdAsNumber < 1000
              ? 6 * 1000 + paramIdAsNumber
              : paramIdAsNumber,
          value: valueAsNumber,
        };
      });

    dataWithStringParameters.stringParameterData =
      dataWithStringParameters.stringParameterData.map((param) => {
        var paramIdAsNumber = parseInt(param.paramId.toString());
        var valueAsString = param.stringValue?.toString();
        return {
          ...param,
          paramId:
            paramIdAsNumber < 1000
              ? 6 * 1000 + paramIdAsNumber
              : paramIdAsNumber,
          stringValue: valueAsString,
        };
      });

    var compHW = this.deviceQuery.hardwareVersions.find(
      (x) => x.ecuId === this.parameter.ecuId,
    );
    if (!compHW) {
      return;
    }

    var compFile = this.definitionQuery.compatibleFile(
      compHW?.ecuId,
      compHW?.buildNumber,
      compHW?.compVersion,
    );
    if (!compFile) {
      return;
    }
    var defaultStringParameters =
      compFile.parameterDefinition.parameterList.filter(
        (param) =>
          !dataWithStringParameters.stringParameterData.find(
            (x) => x.paramId === param.parameterId,
          ) &&
          param.defaultValue !== undefined &&
          param.defaultValue !== null &&
          param.dataType === "STR",
      );

    var defaultParameters = compFile.parameterDefinition.parameterList.filter(
      (param) =>
        !dataWithStringParameters.parameterData.find(
          (x) => x.parameterId === param.parameterId,
        ) &&
        param.defaultValue !== undefined &&
        param.defaultValue !== null &&
        param.dataType !== "STR",
    );

    dataWithStringParameters.parameterData = [
      ...dataWithStringParameters.parameterData,
      ...defaultParameters.map((param) => {
        return {
          parameterId:
            param.parameterId < 1000
              ? 6 * 1000 + param.parameterId
              : param.parameterId,
          ecuId: 6,
          value: param?.defaultValue ?? 0,
          id: 6,
          responseType: "OK",
          status: ParamResponseResult.OK,
          parameter: {
            ...param,
          },
        };
      }),
    ];

    dataWithStringParameters.stringParameterData = [
      ...dataWithStringParameters.stringParameterData,
      ...defaultStringParameters.map((param) => {
        return {
          parameter: {
            ...param,
          },
          stringValue: param.defaultValue?.toString(),
          paramId:
            param.parameterId < 1000
              ? 6 * 1000 + param.parameterId
              : param.parameterId,
          status: ParamResponseResult.OK,
          eventType: StringParameterEventType.READ,
        };
      }),
    ];

    /*console.log(
      'DATA WITH STRINGPARAMETERS',
      dataWithStringParameters,
      'DEFAULT STRING PARAMETERS',
      defaultStringParameters,
      'DEFAULT PARAMETERS',
      defaultParameters
    );*/
    return dataWithStringParameters;
  }

  private mergedataWithoutStringParametersFromDefFile(dataWithoutStringParameters: {
    parameterData: IParameterData[];
  }) {
    // FETCH DEFAULT SETTINGS FOR THE PARAMETERS THAT WERENT UPLOADED AT THE FACTORY

    dataWithoutStringParameters.parameterData =
      dataWithoutStringParameters.parameterData.map((param) => {
        var paramIdAsNumber = parseInt(param.parameterId.toString());
        var valueAsNumber = parseInt(param.value.toString());
        return {
          ...param,
          parameterId:
            paramIdAsNumber < 1000
              ? this.parameter.ecuId * 1000 + paramIdAsNumber
              : paramIdAsNumber,
          value: valueAsNumber,
        };
      });

    var compHW = this.deviceQuery.hardwareVersions.find(
      (x) => x.ecuId === this.parameter.ecuId,
    );
    if (!compHW) {
      return;
    }
    var compFile = this.definitionQuery.compatibleFile(
      compHW?.ecuId,
      compHW?.buildNumber,
      compHW?.compVersion,
    );

    var defaultParameters = compFile?.parameterDefinition.parameterList.filter(
      (param) =>
        !dataWithoutStringParameters.parameterData.find(
          (x) => x.parameterId === param.parameterId,
        ) &&
        param.defaultValue !== undefined &&
        param.defaultValue !== null,
    );
    if (!defaultParameters) {
      return;
    }
    dataWithoutStringParameters.parameterData = [
      ...dataWithoutStringParameters.parameterData,
      ...defaultParameters.map((param) => {
        return {
          parameterId:
            param.parameterId < 1000
              ? this.parameter.ecuId * 1000 + param.parameterId
              : param.parameterId,
          ecuId: this.parameter.ecuId,
          value: param.defaultValue ?? 0,
          id: this.parameter.ecuId,
          responseType: "OK",
          status: ParamResponseResult.OK,
          parameter: {
            ...param,
          },
        };
      }),
    ];

    //console.log('DATA WITHOUT STRINGPARAMS', dataWithoutStringParameters, 'DEFAULTPARAMETERS', defaultParameters);
    return dataWithoutStringParameters;
  }

  private async writeParameters(snapshotOrData: any): Promise<void> {
    this.writingData = true;
    this.deviceService.resetBackupParameters();

    // Support both: Firestore snapshot with .data() and plain object
    const docData =
      snapshotOrData && typeof snapshotOrData.data === "function"
        ? snapshotOrData.data()
        : (snapshotOrData ?? {});

    if (this.parameter.ecuId === 6) {
      let dataWithStringParameters = docData as {
        parameterData?: IParameterData[];
        stringParameterData?: stringparametertemp[];
      };

      // default to [] so for..of never throws
      let parameterData = dataWithStringParameters.parameterData ?? [];
      let stringParameterData =
        dataWithStringParameters.stringParameterData ?? [];

      if (this.fetchFactorySettings) {
        const merged = this.mergedataWithStringParametersFromDefFile({
          parameterData,
          stringParameterData,
        });

        parameterData = merged?.parameterData ?? [];
        stringParameterData = merged?.stringParameterData ?? [];
      }

      // numeric params
      for (const parameter of parameterData) {
        if (parameter.parameterId < 1000) {
          parameter.parameterId = 6 * 1000 + parameter.parameterId;
        }

        if (parameter.parameterId === 6107) {
          parameter.value = 0;
        }

        if (
          !parameter?.parameter ||
          parameter?.parameter?.accessType !== "RO"
        ) {
          var param = {
            parameterId: parameter.parameterId,
            ecuId: parameter.ecuId,
            value: parameter.value,
          };
          this.deviceService.addParameterForBackup(param);
          this.connectApiService.writeParameterToDevice(parameter);
          await this.sleep(100);
        }
      }

      await this.sleep(2500);

      // string params
      for (const parameter of stringParameterData) {
        if (parameter.paramId < 1000) {
          parameter.paramId = 6 * 1000 + parameter.paramId;
        }
        var parameterToWrite: IstringParameterForUpdate = {
          parameterId: parameter.paramId,
          value: parameter.stringValue ?? "",
          ecuId: 6,
        };
        if (
          !parameter.parameter ||
          (parameter?.parameter?.accessType !== "RO" &&
            parameter.paramId !== 6300)
        ) {
          var stringParam = {
            parameterId: parameter.paramId,
            ecuId: 6,
            value: parameter?.stringValue,
          };

          this.deviceService.addParameterForBackup(stringParam);
          this.connectApiService.writeStringParameterToDevice(parameterToWrite);
          await this.sleep(100);
        }
      }
    } else {
      let dataWithoutStringParameters = docData as {
        parameterData?: IParameterData[];
      };
      let parameterData = dataWithoutStringParameters.parameterData ?? [];

      if (this.fetchFactorySettings) {
        const merged = this.mergedataWithoutStringParametersFromDefFile({
          parameterData,
        });
        parameterData = merged?.parameterData ?? [];
      }

      for (const parameter of parameterData) {
        if (parameter.parameterId < 1000) {
          parameter.parameterId =
            parameter.ecuId * 1000 + parameter.parameterId;
        }

        if (parameter.parameterId === 1151 || parameter.parameterId === 2162) {
          parameter.value = 0;
        }

        if (!parameter.parameter || parameter?.parameter?.accessType !== "RO") {
          var param = {
            parameterId: parameter.parameterId,
            ecuId: this.parameter.ecuId as ECU_ID,
            value: parameter.value,
          };
          this.deviceService.addParameterForBackup(param);

          this.connectApiService.writeParameterToDevice(parameter);
          await this.sleep(100);
        }
      }
    }
  }

  private async handleBackUpIsDone(
    res: any,
    currentHardwareNumber: any,
  ): Promise<void> {
    const units: IHardwareVersion[] = res?.unitsToDeactivate ?? [];

    const activeUid =
      this.parameter.ecuId === 6
        ? this.serialNumber
        : `${this.serialNumber}-${currentHardwareNumber}`;

    const unitToSetAsActive = units.find((unit) => unit.uid === activeUid);
    const devicesCol = collection(
      this.angularFirestore,
      CONFIG.firebaseCollection.devices,
    );

    const MAX_RETRIES = 3;
    const RETRY_DELAY_MS = 2000;

    const executeWithRetry = async (
      operation: () => Promise<void>,
      attempt = 1,
    ): Promise<void> => {
      try {
        await operation();
      } catch (error) {
        const code = (error as { code?: string })?.code;
        const isConnectionError =
          code === "unavailable" ||
          code === "deadline-exceeded" ||
          code === "resource-exhausted";

        if (isConnectionError && attempt < MAX_RETRIES) {
          console.warn(
            `Connection issue, retrying attempt ${attempt}/${MAX_RETRIES}...`,
          );
          await new Promise((resolve) =>
            setTimeout(resolve, RETRY_DELAY_MS * attempt),
          ); // exponential backoff
          return executeWithRetry(operation, attempt + 1);
        }

        // Non-retryable error or max retries reached — rethrow to caller
        throw error;
      }
    };

    // Step 1: batch (atomic — either fully commits or fully fails, safe to retry)
    await executeWithRetry(async () => {
      const batch = writeBatch(this.angularFirestore);
      const devicesCol = collection(
        this.angularFirestore,
        CONFIG.firebaseCollection.devices,
      );

      if (unitToSetAsActive) {
        batch.set(
          doc(devicesCol, activeUid),
          { ...unitToSetAsActive, isInactive: false, isSparePart: false },
          { merge: true },
        );
      } else {
        // No previous unit found
        console.warn(
          `No existing unit found for uid: ${activeUid}, skipping batch set`,
        );
      }

      units
        .filter((unit) => unit.uid !== activeUid)
        .forEach((unit) => {
          batch.update(doc(devicesCol, unit.uid), { isInactive: true });
        });

      await batch.commit();
    });

    // Only reached if batch succeeded — creates the full doc if it didn't exist
    this.firestoreService.forceFlag = true;
    await executeWithRetry(() => this.firestoreService.updateFirestoreDevice());
    this.firestoreService.forceFlag = false;
  }
  /*
  private async handleBackUpIsDone(
    res: any,
    currentHardwareNumber: any,
  ): Promise<void> {
    // console.log(this.serialNumber, res?.unitsToDeactivate);
    const units = res?.unitsToDeactivate ?? [];
    console.log("units", units);
    const activeUid =
      this.parameter.ecuId === 6
        ? this.serialNumberInput
        : `${this.serialNumberInput}-${currentHardwareNumber}`;
    console.log("activeUid", activeUid);

    const unitToSetAsActive = units.find(
      (unit: IHardwareVersion) => unit.uid === activeUid,
    );
    console.log("unitToSetAsActive", unitToSetAsActive);
    
    await this.firestoreService.setDeviceAsActive(unitToSetAsActive);
   

    const oldUnits = units.filter(
      (unit: IHardwareVersion) => unit.uid !== activeUid,
    );

    await Promise.all(
      oldUnits.map((unit: IHardwareVersion) =>
        this.firestoreService.setDeviceAsInactive(unit),
      ),
    );
    /*setTimeout(() => {
      units
        .filter((device: any) => device.uid !== activeUid)
        .forEach((unit: IHardwareVersion) => {
          this.firestoreService.setDeviceAsInactive(unit);
        });
      console.log("updateFirestoreDevice");
     
    }, 3000);*/
  /* await this.firestoreService.updateFirestoreDevice();
  }*/

  public back() {
    if (this.step > 1) {
      this.fetchFactorySettings = undefined;
      this.step -= 1;
    }
  }

  private getEcuNameFromEcuId(ecuID: number): string {
    switch (ecuID) {
      case 1:
        return "TCU";

      case 2:
        return "CCU";

      case 6:
        return "HMI";

      default:
        return "Unknown";
    }
  }

  private sleep(time: number) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  public closeModal() {
    this.deviceService.setIsBackuping(false);
    this.softwareVersionHeartBeat = null;
    this.currentSparepartUnit = null;
    this.parametersAndStringParametersForBackupSubscription?.unsubscribe();
    //this.hardwareSubs.unsubscribe();
    this.modalService.dismissModal("SparePartModalComponent");
    if (this.upgradeProgressSubscription) {
      this.upgradeProgressSubscription.unsubscribe();
    }
    this.remoteUserService.removeDataSubscriptions();
    this.remoteUserService.setRemoteSessionInActive();
    // this.modalService.dismissModal('InactiveUnitModalComponent');
  }
  public finishConfiguration() {
    this.deviceService.setIsBackuping(false);
    this.searchingSparePart = false;

    if (this.ecuName === "TCU") {
      this.deviceQuery.specificParameterData$(1151).subscribe((para) => {
        if (para) {
          para.value = 0;
        }
      });
      this.deviceQuery.toggleSparePartFlags(1, false);
    }
    if (this.ecuName === "CCU") {
      this.deviceQuery.specificParameterData$(2162).subscribe((para) => {
        if (para) {
          para.value = 0;
        }
      });
      this.deviceQuery.toggleSparePartFlags(2, false);
    }
    if (this.ecuName === "HMI") {
      this.deviceQuery.specificParameterData$(6107).subscribe((para) => {
        if (para) {
          para.value = 0;
        }
      });
      this.deviceQuery.toggleSparePartFlags(6, false);
    }
    this.parametersAndStringParametersForBackupSubscription?.unsubscribe();
    // console.log("going to dismiss");
    this.modalService.dismissModal("SparePartModalComponent");

    if (this.upgradeProgressSubscription) {
      this.upgradeProgressSubscription.unsubscribe();
    }
    this.items = [];
    this.changedItems = [];
    this.firmwareSparePart = {} as IFirmwareFile;
    this.softwareFile = {} as StorageReference;
    this.fileSelected = false;
    this.isChecked = false;
    this.isFirmwareDiff = false;
    this.softwareVersionHeartBeat = null;
    this.currentSparepartUnit = null;
    this.bleCapacitorService.handleDisconnectForSparePart();
    this.remoteUserService.removeDataSubscriptions();
    this.remoteUserService.setRemoteSessionInActive();
    //this.hardwareSubs.unsubscribe();
  }

  public reSync() {
    this.fetchOldSettings();
    this.ngZone.run(() => {
      this.step = 5;
      this.cdr.markForCheck();
    });
  }

  public async noUnitFound(serialNumber: string): Promise<void> {
    const buttonText = await this.translateService.instant(`auth.ok`);
    var header = this.translateService.instant(`spare parts.error`);
    var message = this.translateService.instant(
      `spare parts.could not find unit`,
      {
        ecuName: this.ecuName,
        serialNumber: serialNumber,
      },
    );

    const body = `<div class="text-center">
    <p class="text-22pt text-roto-green py-2 font-semibold">${header}</p>
      <p class=" text-20pt text-roto-green">${message}</p>
    </div>`;

    const buttons = [
      { text: buttonText, role: "close", cssClass: "no-button-borders" },
    ];
    const alert = await this.alertController.create({
      message: body,
      keyboardClose: false,
      backdropDismiss: false,
      buttons,
    });
    alert.present();

    alert.onDidDismiss().then((res) => {
      // console.log('res: ', res);
      if (res.role === "close") {
        alert.dismiss();
      }
    });
  }

  private async mismatchingSerialNumber(): Promise<void> {
    const buttonText = await this.translateService.instant(`auth.ok`);
    var header = this.translateService.instant(`spare parts.error`);
    var message = this.translateService.instant(
      `spare parts.mismatching serial number`,
    );

    const body = `<div class="text-center">
    <p class="text-22pt text-roto-green py-2 font-semibold">${header}</p>
      <p class=" text-20pt text-roto-green">${message}</p>
    </div>`;
    const buttons = [
      { text: buttonText, role: "close", cssClass: "no-button-borders" },
    ];
    const alert = await this.alertController.create({
      message: body,
      keyboardClose: false,
      backdropDismiss: false,
      buttons,
    });
    alert.present();
    alert.onDidDismiss().then((res) => {
      // console.log('res: ', res);
      if (res.role === "close") {
        alert.dismiss();
      }
    });
  }

  public enterManually() {
    this.manuallyEnterSerialNumber = true;
  }

  public disconnect(): void {
    const currentDevice = this.deviceQuery?.currentDevice;
    this.bleCapacitorService
      .disconnect(currentDevice)
      .then((res) => {
        this.router.navigate(["/"]);
        this.backButtonSubscription?.unsubscribe();
        this.harwareSubscription?.unsubscribe();
        this.deviceService.setIsBackuping(false);
        // this.hardwareSubs.unsubscribe();
        this.parametersAndStringParametersForBackupSubscription?.unsubscribe();
      })

      .catch((err) => {
        console.log(err, "could not disconnect");
      });
  }

  ngOnDestroy(): void {
    this.backButtonSubscription?.unsubscribe();
    this.harwareSubscription?.unsubscribe();
    //this.hardwareSubs.unsubscribe();
    this.deviceService.setIsBackuping(false);
    this.parametersAndStringParametersForBackupSubscription?.unsubscribe();
    if (this.upgradeProgressSubscription) {
      this.upgradeProgressSubscription.unsubscribe();
    }
    this.firmwareService.resetUpdateProgress();
    this.insomnia
      .allowSleepAgain()
      .then((ok) => console.log("APP IS NO LONGER AWAKE", ok))
      .catch((err) => console.log("ERROR", err));

    // this.modalService.dismissModal('SparePartModalComponent');
    //this.modalService.dismissModal('InactiveUnitModalComponent');
  }
}
